export default {
    // apiBaseUrl: 'http://127.0.0.1:3000' // Only set if API runs on a different host/port
}
